import type { App } from 'vue';
import { setupStore } from '../stores';
import router from '../router';
import SvgIcon from "@/components/SvgIcon/index.vue";
import dayjs from "dayjs";
import { vPermission } from '../directives/permission';
import ShowModal from './ShowModal';

export function setupApp(app: App) {
  app.use(setupStore);
  app.use(ShowModal);
  app.use(router);
  app.component("SvgIcon", SvgIcon);
  app.config.globalProperties.$dayjs = dayjs;
  app.config.globalProperties.$timejs = dayjs.unix;
  app.config.globalProperties.$needRefreshConfig = true;
  app.directive('permission', vPermission);
}

